import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

const FilterButton = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;

  &.active {
    background-color: ${theme.colors.AccentNaplesYellow};
    cursor: auto;
  }
`;

export default FilterButton;
